<div class="panel" click-stop-propagation>
  <div class="header d-flex justify-content-between pb-10 fs-14 mb-15">
    <div class="type-selection d-flex">
      <div (click)="showPending = false" [class.selected]="!showPending && !disabled" [class.disabled]="disabled">
        <i *ngIf="showPending || disabled" class="far fa-circle"></i>
        <i *ngIf="!showPending && !disabled" class="fas fa-check-circle"></i>
        <span class="mr-10">
          Previous
          <ng-container *ngIf="!disabled">({{notifications?.length ?? 0}})</ng-container>
        </span>
      </div>
      <div (click)="showPending = true" [class.selected]="showPending && !disabled" [class.disabled]="disabled">
        <i *ngIf="!showPending || disabled" class="far fa-circle"></i>
        <i *ngIf="showPending && !disabled" class="fas fa-check-circle"></i>
        <span>
          Pending
          <ng-container *ngIf="!disabled">({{pendingNotifications?.length ?? 0}})</ng-container>
        </span>
      </div>
    </div>
    <span class="clear-all" (click)="dismissAllNotification()" [class.disabled]="disabled || (!showPending && notifications?.length == 0) || (showPending && pendingNotifications?.length == 0)">Clear All <i class="fas fa-trash-alt ml-5"></i></span>
  </div>
  <div *ngIf="!loading && !disabled" class="notification-host d-flex">
    <div *ngIf="!showPending" class="notification-host-scroll d-flex flex-dir-column">
      <ng-container *ngFor="let notif of notifications">
        <ng-container *ngTemplateOutlet="basicNotif; context: {notif}"></ng-container>
      </ng-container>
      <div *ngIf="notifications?.length == 0" class="align-self-center d-flex pt-10"><span class="fs-12">No Notifications</span></div>
    </div>
    <div *ngIf="showPending" class="notification-host-scroll d-flex flex-dir-column">
      <ng-container *ngFor="let notif of pendingNotifications">
        <ng-container *ngTemplateOutlet="pendingNotif; context: {notif}"></ng-container>
      </ng-container>
      <div *ngIf="pendingNotifications?.length == 0" class="align-self-center d-flex pt-10"><span class="fs-12">No Notifications</span></div>
    </div>
  </div>
  <div *ngIf="!loading && disabled" class="d-flex align-items-center flex-dir-column">
    <span class="fs-14 pt-10">Notifications are currently turned off,</span>
    <span class="fs-14">to turn back on please click on the link below</span>
    <span class="fs-16 pt-10 c-blue bold underline pointer" (click)="manageProfile()">Manage Notifications</span>
  </div>
  <app-spinner *ngIf="loading"></app-spinner>

</div>

<ng-template #basicNotif let-notif="notif">
  <div class="notification d-flex pointer mb-5" (click)="selectedNotification = notif" [class.selected]="selectedNotification?.id == notif.id">
    <div class="notification-icon w-32 h-32">
      <img class="notification-icon-main w-24 h-24 mt-2" src="{{notif.content.iconUrl}}">
    </div>
    <div class="notification-body">
      <div class="d-flex justify-content-between pb-7">
        <span class="bold">{{notif.content.headline}}</span>
        <div class="notification-body-x w-12 h-12 align-items-center justify-content-center" (click)="dismissNotification(notif.id,false)" click-stop-propagation><i class="fs-10 fas fa-times"></i></div>
      </div>
      <div class="notification-body-seperator"></div>
      <div class="d-flex justify-content-between pt-7 max-w-100p">
        <span class="fs-12 bold text-ellipsis" title="{{notif.content.title}}">{{notif.content.title}}</span>
        <span class="fs-12 c-grey-1">{{formatTime(notif.time)}}</span>
      </div>
      <div *ngIf="selectedNotification?.id == notif.id" class="mt-10 mb-10">
        <a *ngFor="let btn of notif.content.buttons" class="button p-5 fs-12 mr-10 pl-10 pr-10 pointer" (click)="navigateToLink(btn.url)">
          {{btn.label}}
        </a>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #pendingNotif let-notif="notif">
  <div class="notification pending d-flex pointer mb-5">
    <div class="notification-icon w-32 h-32">
      <img class="notification-icon-main w-24 h-24 mt-2" src="{{notif.content.pendingUrl}}">
    </div>
    <div class="notification-body">
      <div class="d-flex justify-content-between pb-7">
        <span class="bold">{{notif.content.headline}}</span>
        <div class="notification-body-x w-12 h-12 align-items-center justify-content-center" (click)="dismissNotification(notif.id,true)" click-stop-propagation><i class="fs-10 fas fa-times"></i></div>
      </div>
      <div class="notification-body-seperator"></div>
      <div class="d-flex justify-content-between pt-7 max-w-100p">
        <span class="fs-12 bold text-ellipsis" title="{{notif.content.title}}">{{notif.content.title}}</span>
        <span class="fs-12 c-grey-1">{{formatTime(notif.time)}}</span>
      </div>
    </div>
  </div>
</ng-template>
